import React from 'react';

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
}

const Container: React.FC<ContainerProps> = ({ children, className = '' }) => (
  <div className={`mx-auto w-full max-w-[1224px] ${className} px-[12px]`}>
    {children}
  </div>
);

export default Container;
